module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-brands-400.svg?7afb48012b8e11add2a3b13048bb73d7";